import { render, staticRenderFns } from "./GamesVersionList.vue?vue&type=template&id=3e32d92e&scoped=true&"
import script from "./GamesVersionList.vue?vue&type=script&lang=js&"
export * from "./GamesVersionList.vue?vue&type=script&lang=js&"
import style0 from "./GamesVersionList.vue?vue&type=style&index=0&id=3e32d92e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e32d92e",
  null
  
)

export default component.exports